module.exports = __webpack_public_path__ + "img/8.662d2334.png";